import LandingPage, { type LandingPageContent } from '../LandingPage';

const content: LandingPageContent = {
  eyebrow: 'Inherited Property Strategy',
  headline: 'You Inherited a Home. Now What?',
  subhead:
    'When a luxury property lands in your lap — with its taxes, maintenance, and memories — the last thing you need is pressure. You need a plan.',
  truth:
    'Inheriting a home sounds simple on paper. In reality, it\'s anything but.\n\nMaybe there are multiple heirs who can\'t agree. Maybe the property needs work you can\'t afford. Maybe you live across the country and you\'re managing this from a phone screen.\n\nThe tax clock is ticking, carrying costs are adding up, and every month of indecision costs real money. But rushing into a bad deal isn\'t the answer either.',
  clarityPoints: [
    'Clear valuation so all parties understand what the property is actually worth.',
    'Four distinct selling strategies — from fast cash to maximum return — so heirs can align on priorities.',
    'No-upfront-cost renovation option to capture value without opening your wallet.',
    'Private sale channels that keep family matters out of the public eye.',
    'Coordination with estate attorneys and trustees built into the process.',
  ],
  calm:
    'This doesn\'t have to be a source of family conflict.\nWith the right data and the right plan, everyone can move forward clearly.\n\nYour personalized report maps every option — so the conversation starts with facts, not feelings.',
  ctaText: 'Get My Property Strategy Report',
  pullQuote: 'Not every transition belongs on the market. Not every decision should feel transactional.',
  utmSource: 'sell-inherited',
};

export default function SellInheritedPage() {
  return <LandingPage content={content} />;
}
